import tickets from './tickets';
import statuses from './statuses';
import priorities from './priorities';
import historical from './historical';
import comments from './comments';
import vehicles from './vehicles';
import gps_devices from './gps_devices';
import devices from './devices';
import simcards from './simcards';

export default function* () {
    yield* [
        ...tickets,
        ...statuses,
        ...priorities,
        ...historical,
        ...comments,
        ...vehicles,
        ...gps_devices,
        ...devices,
        ...simcards
    ];
}
